module.exports = __webpack_public_path__ + "static/media/fvs_valve1_72.98632ecb.jpg";